'use client';

import HeaderSkeleton, {
  getHeaderManifest,
  type OwnProps as HeaderProps
} from '@carvana/header';
import { useClientSide } from '@carvana/merch-react-hooks';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useContext, useEffect } from 'react';
import { commonEnvironment, environment } from '~/constants/environment';
import StaticContext from '~/context/common/StaticContext';
import { wait } from '~/utilities';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

function PageHeader() {
  const { removeHeader, serverCookies } = useContext(StaticContext);
  const isClientSide = useClientSide();

  useEffect(() => {
    if (removeHeader) return;

    wait(100).then(() => {
      void MfeLoad({
        files: [
          [
            'HeaderModule',
            [
              {
                component: 'default',
                default: {
                  file: 'index.js',
                  manifest: getHeaderManifest(environment)
                }
              }
            ]
          ]
        ]
      });
    });
  }, [removeHeader]);

  const headerProps: HeaderProps = {
    cookies: serverCookies,
    environment: commonEnvironment
  } as HeaderProps;

  if (removeHeader) return null;

  return isClientSide ? (
    <MfeReactComponent
      component="default"
      fallback={{
        Component: <HeaderSkeleton {...headerProps} />,
        timeout: 30000
      }}
      loading={<HeaderSkeleton {...headerProps} />}
      module="HeaderModule"
      {...headerProps}
    />
  ) : (
    <HeaderSkeleton {...headerProps} />
  );
}

export default withErrorBoundary(PageHeader);
